module.exports = __webpack_public_path__ + "static/media/top.c2d89f06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tandem/top.jpg
// module id = 291
// module chunks = 0